import { GET_API } from './index';
import * as SYSTEM from '../constants/system.keys';

export const getMonitoringData = async (token, dataHeader, dataQuery) => {
  return GET_API(
    `${SYSTEM.SERVER_URL_CMS}/dashboards`,
    token,
    dataHeader,
    dataQuery,
  );
};
